/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_ResumeInputs */



/**
* | output |
* | --- |
* | "Resume recording" |
*
* @param {Meeting_Offline_ResumeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_resume = /** @type {((inputs?: Meeting_Offline_ResumeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_ResumeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opname hervatten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reprendre l'enregistrement")
	return /** @type {LocalizedString} */ ("Resume recording")
});